import { render, staticRenderFns } from "./ActChange.vue?vue&type=template&id=fb2a6710&scoped=true"
import script from "./ActChange.vue?vue&type=script&lang=js"
export * from "./ActChange.vue?vue&type=script&lang=js"
import style0 from "./ActChange.vue?vue&type=style&index=0&id=fb2a6710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2a6710",
  null
  
)

export default component.exports